import * as TYPES from './types.js';
export default {
    // 设置 listingStatus 的值
    [TYPES.SET_LISTING_STATUS](state, payload = {}) {
        state.listingStatus = [...payload.data];
    },
    // 设置 listing 的值
    [TYPES.SET_LISTING](state, payload = {}) {
        state.listing = [...payload.data];
    },

    // 设置 currentListingStatus 的值
    [TYPES.SET_CURRENT_LISTING_STATUS](state, payload = {}) {
        state.currentListingStatus = payload.data;
    },
    // 设置 currentListingStatus 的值
    [TYPES.SET_FETCH_LISTING_STATUS](state, payload = {}) {
        state.fetchListingStatus = payload.data;
    },
    [TYPES.SET_CURRENT_LISTING_NAME](state, payload = {}) {
        state.currentListingStatusName = payload.data;
    },
    [TYPES.SET_SEARCH_PARAMS](state, payload = {}) {
        state.searchParams = { ...payload };
    },
    // 设置分页的总页数
    [TYPES.SET_TOTAL_PAGE](state, payload = {}) {
        state.totalPage = payload.data;
    },
    // 设置当前页
    [TYPES.SET_PAGE_NUM](state, payload = {}) {
        state.pageNum = payload.data;
    },
    // 是否显示sold listing price
    [TYPES.SET_SHOW_SOLD_LISTING_PRICE](state, payload = {}) {
        state.showSoldPrice = payload.data;
    },
    // 是否显示listing price
    [TYPES.SET_SHOW_LISTING_PRICE](state, payload = {}) {
        state.showListingPrice = payload.data;
    },
    [TYPES.SET_HAS_LOCATION](state, payload = {}) {
        state.hasLocation = payload.data;
    },
    // 已售房源信息
    [TYPES.SET_SOLD_LISTING_INFO](state, payload = {}) {
        state.soldListingInfo = payload.data;
    }
};
